import type { PImage } from '../../../engine/aliases'
import { ga } from '../../../engine/ga-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { l } from '../../../lib/imports'
import { largeSprites } from '../../../sprites/largeSprites'
import { spritesUtil } from '../../../sprites/spritesUtil-sidecar'
import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessGameManager } from '../chessGameManager-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessTestParams } from '../chessTestParams-sidecar'
import { chessWebsockets } from '../messages/chessWebsockets-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import type { IChessUiGButton } from './chessUiGButtons'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiMenuMain_credits } from './chessUiMenuMain_credits-sidecar'
import { chessUiMenuMain_news } from './chessUiMenuMain_news-sidecar'
import { chessUiMessage } from './chessUiMessage-sidecar'
import { chessUiMultiListGames } from './chessUiMultiListGames-sidecar'
import { chessUiSetupAI } from './chessUiSetupAI-sidecar'

interface IChessUiMenuMain extends IChessUiCanvas {
  //spriteBackground: PImage
  imageLogo: PImage
  isMultiplayerOpen: boolean
  buttonMultiName: IChessUiGButton | null
  multiplayerButtons: IChessUiGButton[]
}

let _obj: IChessUiMenuMain | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    setBackgroundOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  // TODO: new sprite
  // let sprite = largeSprites.goatBackgroundMenuMain

  // let spriteBackground = spritesUtil.createLargeSprite(
  //   voyageLayers.getLayers().uiMenuMain,
  //   sprite,
  // )

  // let tw = 1920 - 100
  // let th = 1080 - 200

  let tw = 1000
  let th = 1000

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiMenuMain)
  canvas.autoOffset = true

  let imageLogo = spritesUtil.createLargeSprite(
    // chessLayers.getLayers().uiMenuMain,
    canvas.layer,
    largeSprites.untilYourKingIsDeadLogo2,
  )
  imageLogo.scale = 1

  // canvas.ox = 170 //1000
  // canvas.oy = 240

  let obj: IChessUiMenuMain = chessUiCanvas.assign<IChessUiMenuMain>(canvas, {
    isMultiplayerOpen: false,
    multiplayerButtons: [],
    buttonMultiName: null,
    imageLogo: imageLogo,
    //spriteBackground,
  })

  let x = 20
  let y = 40
  const addButton = (text: string, action: () => void) => {
    let button = chessUiGButtons.create(text, x, y, action)
    button.w = 200
    obj.buttons.push(button)
    y += 80
    return button
  }

  y += 400

  const changeName = () => {
    let newName =
      prompt('What is your name?', chessWebsockets.getMultiName()) || ''
    newName = newName.trim()
    if (newName) {
      if (newName.length > 128) {
        newName = newName.substring(0, 128)
      }
      websockets.setMultiName(newName)
    }
  }

  let sx = x
  let sy = y

  let tempX = x
  let tempY = y

  // if (obj.isMultiplayerOpen) {
  x += 230

  obj.multiplayerButtons.push(
    addButton('Join Game', () => {
      ga.action('click', 'join')
      websockets.setSingleplayer(false)
      chessUiMultiListGames.setOpen(true)
    }),
  )

  obj.multiplayerButtons.push(
    addButton('Host Public', () => {
      ga.action('click', 'host-public')
      setOpen(false)
      setBackgroundOpen(false)
      websockets.setSingleplayer(false)
      websockets.hostChannel('')
    }),

    addButton('Host Private', () => {
      ga.action('click', 'host-private')
      setOpen(false)
      setBackgroundOpen(false)
      websockets.setSingleplayer(false)

      let password = '' + (prompt('Password?', '') || '')
      websockets.hostChannel(password)
    }),
  )

  obj.multiplayerButtons.push(
    (obj.buttonMultiName = addButton('Change name', () => {
      ga.action('click', 'change-name')
      changeName()
    })),
  )

  // }

  x = tempX
  y = tempY

  addButton('Multiplayer', () => {
    ga.action('click', 'multiplayer')
    obj.isMultiplayerOpen = !obj.isMultiplayerOpen

    if (chessWebsockets.getMultiName() === 'NewPlayer') {
      changeName()
    }
  })

  addButton('Singleplayer', () => {
    ga.action('click', 'singleplayer')
    setOpen(false)
    setBackgroundOpen(false)
    websockets.setSingleplayer(true)
    chessGameManager.goGame()
    chessUiSetupAI.setOpen(true)
  })

  x = sx + 762
  y = sy

  addButton('Credits', () => {
    chessUiMenuMain_credits.onCredits()
  })

  addButton('v' + chessTestParams.version + ' News', () => {
    chessUiMenuMain_news.onNews()
  })

  addButton('Website', () => {
    ga.action('click', 'website')
    window.open('https://keepflyinggames.com')
  })
  addButton('Discord', () => {
    ga.action('click', 'discord')
    window.open('https://keepflyinggames.com/discord')
  })
  // addButton('Early Access', () => {
  //   goatUiMessage.setText(
  //     'Early Access',
  //     'You may encounter bugs and things may change!',
  //   )
  //   goatUiMessage.setOpen(true)
  // })

  return obj
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  obj.imageLogo.x = obj.ox
  obj.imageLogo.y = obj.oy

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)

    obj.texts.push(_text)
    return _text
  }

  let x = 0
  let y = 0
  let w = 200
  let h = 400

  l.forEach(obj.multiplayerButtons, (c) => {
    c.isVisible = obj.isMultiplayerOpen
  })

  let b = obj.buttonMultiName
  if (b) {
    if (obj.isMultiplayerOpen) {
      addText('' + websockets.getMultiName(), b.x + 210, b.y + 22)
    }
  }

  // assert.notNil(obj.buttonMultiName)
  //obj.buttonMultiName.text = '' + chessWebsockets.getMultiName()

  // voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
  // addText('Main Menu', x + 6, y) // + 25 - 2)

  x = 300 + 20
  y = 0
  w = 1000 - 20
  h = 400

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  obj.imageLogo.visible = isOpen
  chessLayers.getLayers().board.visible = !isOpen
  if (isOpen) {
    setBackgroundOpen(true)
  }
  update()
}

export const setBackgroundOpen = (isOpen: boolean) => {
  let obj = get()
  // obj.spriteBackground.visible = isOpen
  // obj.spriteBackground.visible = false
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    let gb = chessCamera.getGameBounds()

    // Adjust background image
    {
      let bw = 3440
      let bh = 1440

      let ox = (gb.width - bw) / 2
      let oy = (gb.height - bh) / 2

      // obj.spriteBackground.scale = 1
      // obj.spriteBackground.x = ox
      // obj.spriteBackground.y = oy
    }

    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
